import { ChangeEventHandler, FunctionComponent, MouseEventHandler } from 'react';
import { FelaCSS, RadioToggleWrapV2, TColor } from '@bridebook/ui';
import Box from '../../../../components/fela/Box';
import { IStylingProps } from '../../../../themes/types';
import componentStyles from './radio-toggle-v2.style';

export interface SharedTypes {
  block?: boolean;
  checked?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
}

interface PropTypes extends SharedTypes, IStylingProps {
  id: string;
  value?: string;
  name: string;
  label: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onClick?: MouseEventHandler<HTMLInputElement>;
  icon?: Function;
  iconColor?: TColor;
  iconWidth?: number;
  autoFocus?: boolean;
  wrapperStyle?: FelaCSS;
}

const RadioToggleV2: FunctionComponent<PropTypes> = ({
  label,
  block,
  checked,
  defaultChecked,
  disabled,
  icon,
  iconColor,
  iconWidth,
  id,
  value,
  name,
  onChange,
  onClick,
  autoFocus,
  wrapperStyle,
  ...restProps
}) => {
  const Icon = icon;

  const activated = checked || defaultChecked;

  const styles = componentStyles({
    disabled,
    checked: activated,
  });

  return (
    <RadioToggleWrapV2
      block={block}
      checked={checked}
      defaultChecked={defaultChecked}
      disabled={disabled}
      id={id}
      value={value}
      name={name}
      onChange={onChange}
      onClick={onClick}
      autoFocus={autoFocus}
      {...restProps}>
      <Box style={wrapperStyle ? { ...styles.wrapper, ...wrapperStyle } : styles.wrapper}>
        {Icon && (
          <Box style={styles.iconWrap}>
            <Icon width={iconWidth} checked={checked} color={iconColor} />
          </Box>
        )}
        <Box style={styles.label}>{label}</Box>
      </Box>
    </RadioToggleWrapV2>
  );
};

export default RadioToggleV2;
